import React, { useRef, useState} from "react";
import { Track } from 'livekit-client';
import { LuScreenShare, LuScreenShareOff } from "react-icons/lu";
import { BsFillCameraVideoFill, BsFillCameraVideoOffFill } from "react-icons/bs";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";

import { useTrackToggle } from "@livekit/components-react";

const controlsSettingsMap = {
    'camera': {
        source: Track.Source.Camera,
        iconActive: BsFillCameraVideoOffFill,
        iconInactive: BsFillCameraVideoFill
    },
    'audio': {
        source: Track.Source.Microphone,
        iconActive: FaMicrophoneSlash,
        iconInactive: FaMicrophone
    },
    'screen': {
        source: Track.Source.ScreenShare,
        iconActive: LuScreenShareOff,
        iconInactive: LuScreenShare
    },
}

const VideoControlTrack = ({type}) => {

    const [controlsSettings, ] = useState(controlsSettingsMap[type])

    const {buttonProps, enabled} = useTrackToggle({
        source: controlsSettings.source,
        initialState: false
    })

    const trackRef = useRef()
    return (<button ref={trackRef} {...buttonProps} className="w-[47px] h-[42px] text-white flex items-center justify-center text-[24px] rounded-2xl bg-[#87858F] ">
        {enabled ? <controlsSettings.iconActive /> : <controlsSettings.iconInactive />}
    </button>)
}

export default VideoControlTrack